/*
 * Native sticky header support.
 *
 * Sets --header-top to the negative height of the currently visible utility bar
 * so that, with `header[role="banner"] { position: sticky; top: var(--header-top) }`
 * (see style_sections_toggle-header.css), the utility bar scrolls off-screen
 * while the title + menu bars pin to the top of the viewport.
 *
 * This replaces the old JS-driven slide-down nav (now hidden). The utility bar
 * height differs by breakpoint (mobile bar lives outside .toggle-header__outer,
 * desktop bar inside it) and can change with promo content / B2B<->DTC switches,
 * so it's measured on load, on resize, and whenever the header resizes.
 *
 * Requires overflow-x: clip (not hidden) on html/body — see custom-style.css.
 */
(function () {
  function visibleUtilityBarHeight() {
    var els = [
      document.querySelector('.toggle-header__utility-bar.mobile'),
      document.querySelector('.toggle-header__inner-container > .toggle-header__utility-bar')
    ];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el && el.offsetParent !== null && el.offsetHeight > 0) return el.offsetHeight;
    }
    return 0;
  }

  function update() {
    var utilH = visibleUtilityBarHeight();
    var banner = document.querySelector('header[role="banner"]');
    var bannerH = banner ? banner.offsetHeight : 0;
    document.documentElement.style.setProperty('--header-top', '-' + utilH + 'px');
    // --sticky-header-height = the part of the header that stays pinned at the top
    // once stuck (banner minus the utility bar that scrolls off). Other sticky UI
    // (collection filters, bundle bars) offsets itself by this so it sits below
    // the pinned header instead of behind it.
    document.documentElement.style.setProperty('--sticky-header-height', Math.max(0, bannerH - utilH) + 'px');
  }

  function debounce(fn, wait) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  }

  function init() {
    update();
    window.addEventListener('resize', debounce(update, 200));
    // Recompute if the header's own height changes (promo bars, B2B/DTC toggle,
    // font swaps). Writing --header-top only changes the sticky offset, not the
    // header's box, so this can't loop.
    var banner = document.querySelector('header[role="banner"]');
    if (banner && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(debounce(update, 200)).observe(banner);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
